var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showSupplierForm
        ? _c("SupplierForm", {
            attrs: {
              "form-action": _vm.supplierFormAction,
              "supplier-id": _vm.editedSupplierId
            },
            on: {
              canceled: function($event) {
                _vm.showSupplierForm = _vm.showSettingsForm = false
              }
            }
          })
        : _vm.showSettingsForm
        ? _c("SettingsForm", {
            attrs: { "supplier-id": _vm.editedSupplierId },
            on: {
              canceled: function($event) {
                _vm.showSettingsForm = _vm.showSupplierForm = false
              }
            }
          })
        : _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-row",
                { staticClass: "table-header" },
                [
                  _c("span", [_vm._v("Supplier")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { float: "right", padding: "3px 0" },
                      attrs: { type: "text" },
                      on: { click: _vm.handleCreate }
                    },
                    [_vm._v("Hinzufügen")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row"),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading"
                        }
                      ],
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.suppliers }
                    },
                    [
                      _vm._l(_vm.tableColumns, function(col, index) {
                        return _c("el-table-column", {
                          key: index,
                          attrs: {
                            label: col.label,
                            prop: col.prop,
                            align: "center",
                            formatter: col.formatter,
                            width: _vm.getColumnWidth(col)
                          }
                        })
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          fixed: "right",
                          width: "120px"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleEdit(scope.row.id)
                                      }
                                    }
                                  },
                                  [_vm._v("Bearbeiten")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleSettings(scope.row.id)
                                      }
                                    }
                                  },
                                  [_vm._v("Einstellungen")]
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b974f74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b974f74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/suppliers/Suppliers.vue
// module id = null
// module chunks = 